// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2rqc5","inputWrap":"Table_inputWrap__lZ8Uw","col":"Table_col__3fBW2","bmiTooltip":"Table_bmiTooltip__S8a72"};